<template>
  <table class="table my-3 table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
    <thead>
    <tr>
      <th>شناسه</th>
      <th>نام</th>
      <th>فرم</th>
      <th>امتیاز</th>
      <th>تاریخ پاسخ</th>
      <th>#</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in items">
      <th>{{ item.id }}</th>
      <td>
        {{ item.user.name }} {{ item.user.last_name }}

        <router-link target="_blank" class="p"
                     :to="{ name: 'UpdateUser', params: { id: item.user.id } }">
          (پروفایل)
        </router-link>
      </td>
      <td>{{ item.form.name }}</td>
      <td>
        {{ item.score }}
      </td>
      <td>
        <span dir="ltr"> {{ dateConverter(item.created_at, '/', true) }}</span>
      </td>
      <td>

        <router-link target="_blank" class="h5"
                     :to="{ name: 'FormAnswer', params: { form_fill: item.id,user:item.user.id } }"
        >
          <b-icon icon="archive-fill" class="h5 mr-3"></b-icon>
        </router-link>

      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "FormTableItems",
  methods: {dateConverter},
  props: {
    items: {
      default: []
    }
  }
}
</script>

<style scoped>

</style>